import { nextTick } from 'vue'
import i18n from '@src/i18n/index.js'

const $t = i18n?.global?.t

const translate = (element, binding) => {
  nextTick(() => {
    const originalText =
      element.dataset.i18nOriginal !== undefined
        ? element.dataset.i18nOriginal
        : element.innerText.trim()

    if (element.dataset.i18nOriginal === undefined) {
      element.dataset.i18nOriginal = originalText
    }

    const scope = binding.value || binding.expression || ''
    const key = scope ? `${scope}.${originalText}` : originalText
    const translated = $t ? $t(key) : originalText

    element.innerText = translated
  })
}

export default {
  mounted(element, binding) {
    translate(element, binding)
  },
  updated(element, binding) {
    translate(element, binding)
  },
}
